// extracted by css-extract-rspack-plugin
export default {"icon":"CR160","mark":"Hg7f3"};